// extracted by mini-css-extract-plugin
export default {"SpinnerArea":"Spinner_SpinnerArea__sEJXK","Center":"Spinner_Center__g6jdU","Spinner":"Spinner_Spinner__x6t0Z","load8":"Spinner_load8__ft0Ge","Small":"Spinner_Small__GqKux"};